import { useGridApiContext } from '@mui/x-data-grid-pro';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const CustomToolBarExportButton = ({ from, selectedMappingType }) => {
  const apiRef = useGridApiContext();
  const formattedDate = new Intl.DateTimeFormat('fr-FR').format(new Date());
  const baseName = from === 'mappingCulture' ? 'cultures' : 'ground-types';
  const fileName = `${baseName}_${selectedMappingType}_${formattedDate}`;
  const { t } = useTranslation();

  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      utf8WithBom: true,
      delimiter: ';',
      fileName: fileName,
    });
  };

  return (
    <Button variant="outlined" startIcon={<FileDownloadIcon />} onClick={handleExport}>
      {t('datagrid.exportCsv')}
    </Button>
  );
};
